module.exports = {"chartData":[{"category":"2020/10","payed":100,"useage":100},{"category":"2020/11","payed":100,"useage":100},{"category":"2020/12","payed":100,"useage":100},{"category":"2021/01","payed":100,"useage":100},{"category":"2021/02","payed":100,"useage":100},{"category":"2022/03","payed":100,"useage":100}],"filter":["payed","useage"]}


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/components/UsageCostAndPaymentStatusDummy.json
// module id = GzDf
// module chunks = 4